<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="d-flex align-items-center">
          <div class="filter-items mr-3">
            <label class="txt-right bold mb-0">Công ty</label>
            <DropdownScrollable
              width="100%"
              :disabled="Boolean(company_id)"
              :loading="company_obj.loading"  
              v-model="company" 
              :options="company_obj.items"
              :total="company_obj.total" 
              @keyup="emitEvent" 
              @offset="changeOffset"
            />
          </div>
          <div class="filter-items mr-3">
            <label class="txt-right bold mb-0">Bộ phận</label>
            <DropdownScrollable
              width="100%"
              :loading="department_obj.loading"
              v-model="department"
              :options="department_obj.items"
              :total="department_obj.total"
              @keyup="emitEventDepartment"
              @offset="changeOffsetDepartment"
            />
          </div>
          <div class="filter-items mr-3">
            <label class="txt-right bold mb-0">Người dùng</label>
            <DropdownScrollable
              width="100%"
              :loading="user_obj.loading"
              v-model="user"
              :options="user_obj.items"
              :total="user_obj.total"
              @keyup="emitEventUser"
              @offset="changeOffsetUser"
            >
            <template #label="slotProps">
              <div class="p-clearfix">
                <span>{{ slotProps.username + " - " + slotProps.fullname }}</span>
              </div>
            </template>
            </DropdownScrollable>
          </div>
          <div class="filter-btn">
            <label class="txt-right bold mb-0 visibility-hidden">Action</label>
            <Button icon="pi pi-plus" class="btn-success" @click="addGroupUser" v-if="$store.getters.controllers?.list_group && ($store.getters.controllers?.list_group.includes('add') || $store.getters.controllers?.list_group.includes('edit'))"/>
          </div>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          :group_id="group_id"
          :company_id="company_id"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xoá người dùng này khỏi nhóm quyền không?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" id="warning_poins_errs">
          <span class="txt-center">
            Người dùng không được bỏ trống!
          </span>
          <template
              #footer
              class="justify-content-center"
            >
            <Button label="Xác nhận" @click="popupWarning = false" icon="pi pi-check" class="" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      group_id: null,
      group_name: null,
      company: {},
      department: {},
      user: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      user_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      company_id: null,
      popupWarning: false,
      changed: false
    }
  },
  // mounted () {
    
  // },
  async created() {
    if (this.$route.params.id !== undefined) this.group_id = this.$route.params.id;
    if (this.$route.query.group_name !== undefined) this.group_name = this.$route.query.group_name;
    this.initParams();
    if (!this.changed) {
      await this.getListCompany();
    }
    if (this.$route.query.company_id !== undefined) {
      this.company_id = this.$route.query.company_id;
      this.company = {id: this.company_id};
    }
    this.modelName = this.$route.meta.model;
    // this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name;
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    this.changed = false;
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      this.user = null;
      this.department = null;
      // await this.getListDepartment();
      // await this.getListUser();
    },
    async 'department'() {
      this.user = null;
      // await this.getListUser();
    }
  },
  methods: {
    async addGroupUser() {
      if (this.$commonFuction.isEmpty(this.user) || this.$commonFuction.isEmptyObject(this.user)) {
        this.popupWarning = true;
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/group/group_user_add", {group_id: this.group_id, uid: this.user.id}, {headers}).then(async () => {
          this.changed = true;
          this.componentKey++;
          this.user = null;
          await this.getListUser();
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.company_obj.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: 20, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.company_obj.items.push(...res.data.data.company);
          } else {
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      console.log(keyword);
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      this.department_obj.loading = true;
        var company_id = this.company_id;
        if (this.$commonFuction.isEmpty(company_id)) {
          company_id = this.company.id;
        }
      if(token && company_id){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: company_id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.total;
            this.department_obj.loading = false;
            this.changed = true;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    async emitEventUser(keyword) {
      this.$delete(this.user_obj.filters, 'name');
      if (keyword) {
        this.user_obj.filters.name = keyword;
      }
      await this.getListUser();
    },
    async changeOffsetUser(value) {
      this.user_obj.offset = value;
      // await this.getListUser();
    },
    async getListUser() {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      var company_id = this.company_id;
      if (this.$commonFuction.isEmpty(company_id)) {
        company_id = this.company.id;
      }
      this.user_obj.filters.department_id = this.department?.id;
      this.user_obj.filters.group_id = this.group_id;
      if(token && company_id){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.user_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.user_obj.filters, limit: 20, offset: this.user_obj.offset, company_id: company_id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.user_obj.items.push(...res.data.data.list);
          } else {
            this.user_obj.items = res.data.data.list;
          }
          this.user_obj.total = res.data.data.count;
          this.user_obj.loading = false;
          this.changed = true;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      if (this.group_name) {
        this.title = this.title + " - " + this.group_name;
      }
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        if (that.$store.getters.controllers?.list_group && that.$store.getters.controllers?.list_group.includes('edit')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'uid'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields(0);
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'calculator':
          this.dialogMode = action.name
          this.$router.push({ path: action.path, query: { group_id: data.data[action.key] }  })
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/group/group_user_delete", {uid: that.deleteId, group_id: this.group_id}, {headers}).then(async function () {
          that.changed = true;
          that.componentKey += 1;
          await that.getListUser();
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    }
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.filter-items {
    flex-basis: 33%;
}
.filter-btn {
    flex-basis: 1%;
}
#warning_poins_errs {
  width: 600px;
}
</style>